import { render } from "./SwiperSliderPage.vue?vue&type=template&id=72e3259e&ts=true"
import script from "./SwiperSliderPage.vue?vue&type=script&lang=ts"
export * from "./SwiperSliderPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__